export default "__VITE_ASSET__d637ca79__"